import { FiltersModal as BaseFiltersModal, type FiltersModalProps } from '@noor/ui';

/** CPanel filter dialogs place secondary actions before the Apply button. */
export function FiltersModal(props: FiltersModalProps) {
  return <BaseFiltersModal {...props} applyLast />;
}
